import React from "react";
import { Breadcrumb } from "semantic-ui-react";
import "../../styles/modal.scss";

const BCModalHeaderBreadcrumb = ({ modal, subModal, setModal, setSubModal }) => {
  const handleBackToModal = () => {
    setModal(true);
    setSubModal(false);
  };

  return (
    <Breadcrumb size={"huge"}>
      {!subModal && <Breadcrumb.Section className="primary-breadcrumb" active>{modal}</Breadcrumb.Section>}
      {subModal && <React.Fragment>
        <Breadcrumb.Section className="primary-breadcrumb"
          link
          onClick={() => handleBackToModal()}
        >
          {modal}
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon='right chevron' />
      </React.Fragment>}
      {subModal && <Breadcrumb.Section active>{subModal}</Breadcrumb.Section>}
    </Breadcrumb>
  );
};

export default BCModalHeaderBreadcrumb;
